import React, { useEffect } from 'react';
import { UrgencyBar } from '../components/UrgencyBar';
import { HeroSection } from '../components/HeroSection';
import { PainAgitationSection } from '../components/PainAgitationSection';
import { ProductRevealSection } from '../components/ProductRevealSection';
import { TimelineSection } from '../components/TimelineSection';
import { OfferSection } from '../components/OfferSection';
import { FaqSection } from '../components/FaqSection';
import { Footer } from '../components/Footer';
import { initFBPixel, trackPageView } from '../utils/fbPixel';
export function LandingPage() {
  useEffect(() => {
    initFBPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-[#FFF9F0] font-sans selection:bg-[#E8820C]/30 selection:text-[#2D1B06]" data-id="element-134">
      <UrgencyBar data-id="element-135" />

      <main data-id="element-136">
        <HeroSection data-id="element-137" />
        <PainAgitationSection data-id="element-138" />
        <ProductRevealSection data-id="element-139" />
        <TimelineSection data-id="element-140" />
        <OfferSection data-id="element-141" />
        <FaqSection data-id="element-142" />
      </main>

      <Footer data-id="element-143" />
    </div>;
}